import { hoursToMinutes, minutesToHours } from '@acme/common'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Registro } from 'service/api'
import { match } from 'ts-pattern'

export const SaldoDiarioCell: React.FC<GridCellParams<Registro[]>> = ({
    row,
}) => {
    const saldo = hoursToMinutes(row.horasExtra) - hoursToMinutes(row.faltas)

    return match(saldo)
        .when(
            x => x == 0,
            () => ' 00:00',
        )
        .when(
            x => x < 0,
            x => `-${minutesToHours(Math.abs(x))}`,
        )
        .otherwise(x => `+${minutesToHours(x)}`)
}
